import { parse, format } from "date-fns";
import log from "@/utils/logger";

export default {
    methods: {
        dateToQueryParam(date)
        {
            if (!date)
            {
                return null;
            }

            return format(date, "yyyy-MM-dd");
        },
        parseDateFromQueryParam(dateString)
        {
            let date = new Date();

            try
            {
                let newDate = parse(dateString, "yyyy-MM-dd", new Date());
                if (newDate instanceof Date && !isNaN(newDate))
                {
                    date = newDate;
                }
            }
            catch (e)
            {
                log.error("Failed to parse date value [%s] - %o", dateString, e);
            }

            return date;
        }
    }
}